module.exports = __webpack_public_path__ + "media/customizations/fieldslife/back-7fa53f946c7f731172eb0dc67845d830.jpg";